import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/(sub-layout)/bizking/@section7/page.tsx");
